"use strict";function close$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.close$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.navigation.close";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.3.5"},_a)),exports.close$=close$,exports.default=close$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/navigation/close.js
// module id = 969
// module chunks = 106